import { ListChecksIcon, WorkflowIcon } from 'lucide-react';
import { createElement } from 'react';

import { defineModule } from '@/shared/registry/types';

import { ItemSearchResult } from './components/SearchResult';
import { LazyItemPanel, LazyProcessComposerTab } from './lazy';
import { registerListsRealtime } from './realtime';

/**
 * `lists` module — universal lists (docs/modules/lists.md): the catalog (`/lists`), a list's table (`/lists/:listId`)
 * and its settings (`/lists/:listId/settings`: general, fields, access), the item card panel `list-item:<id>` and the
 * new-item form `list-item:new?listId=` (and `list-item:copy-<itemId>`: a new request filled like an earlier one), the search
 * renderer of items, and the «Process» tab of the feed's composer (`feedComposerTabs`: the employee processes — vacation,
 * trip, expense report — started from the feed).
 */
export const module = defineModule({
  id: 'lists',
  routes: [
    {
      path: 'lists',
      children: [
        { index: true, lazy: async () => ({ Component: (await import('./pages/ListsPage')).default }) },
        { path: ':listId', lazy: async () => ({ Component: (await import('./pages/ListPage')).default }) },
        {
          path: ':listId/settings',
          lazy: async () => ({ Component: (await import('./pages/ListSettingsPage')).default }),
        },
        { path: '*', lazy: async () => ({ Component: (await import('./pages/ListsPage')).default }) },
      ],
    },
  ],
  nav: [
    {
      id: 'lists',
      labelKey: 'lists:nav.title',
      icon: ListChecksIcon,
      to: '/lists',
      order: 85,
      section: 'main',
    },
  ],
  sidePanels: [{ type: 'list-item', component: LazyItemPanel, size: 'lg', titleKey: 'lists:panel.title' }],
  searchRenderers: { item: ItemSearchResult },
  feedComposerTabs: [
    {
      id: 'process',
      labelKey: 'lists:composer.tab',
      icon: WorkflowIcon,
      order: 100,
      element: ({ onDone }) => createElement(LazyProcessComposerTab, { onDone }),
    },
  ],
  setup: ({ realtime, queryClient }) => {
    registerListsRealtime(realtime, queryClient);
  },
});
